(() => {
  if (window.mmDigitalConsentInitialized) return;
  window.mmDigitalConsentInitialized = true;

  const initializeConsent = (container) => {
    if (container.dataset.mmDigitalConsentReady === 'true') return;

    const checkbox = container.querySelector('[data-mm-digital-consent-checkbox]');
    const timestamp = container.querySelector('[data-mm-digital-consent-timestamp]');
    const error = container.querySelector('[data-mm-digital-consent-error]');
    if (!checkbox || !timestamp || !error) return;

    container.dataset.mmDigitalConsentReady = 'true';
    checkbox.checked = false;
    timestamp.value = '';

    const updateState = () => {
      if (checkbox.checked) {
        timestamp.value = new Date().toISOString();
        error.hidden = true;
        checkbox.setCustomValidity('');
      } else {
        timestamp.value = '';
      }
    };

    checkbox.addEventListener('change', updateState);
    checkbox.addEventListener('invalid', () => {
      if (!checkbox.checked) {
        checkbox.setCustomValidity(
          'Bitte bestätige den Sofortbeginn und den Verlust des Widerrufsrechts.'
        );
        error.hidden = false;
      }
    });
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-mm-digital-consent]').forEach(initializeConsent);
  };

  const consentForForm = (form) => {
    if (!form) return null;
    return Array.from(document.querySelectorAll('[data-mm-digital-consent-checkbox]')).find(
      (checkbox) => checkbox.form === form
    ) || null;
  };

  const blockWithoutConsent = (event, form) => {
    const checkbox = consentForForm(form);
    if (!checkbox || checkbox.checked) return false;

    event.preventDefault();
    event.stopImmediatePropagation();
    checkbox.setCustomValidity(
      'Bitte bestätige den Sofortbeginn und den Verlust des Widerrufsrechts.'
    );
    const container = checkbox.closest('[data-mm-digital-consent]');
    const error = container?.querySelector('[data-mm-digital-consent-error]');
    if (error) error.hidden = false;
    checkbox.reportValidity();
    checkbox.focus();
    return true;
  };

  const start = () => {
    initializeAll();
    document.addEventListener(
      'click',
      (event) => {
        const checkoutButton = event.target.closest('[name="checkout"]');
        if (!checkoutButton) return;
        blockWithoutConsent(event, checkoutButton.form);
      },
      true
    );
    document.addEventListener(
      'submit',
      (event) => {
        blockWithoutConsent(event, event.target);
      },
      true
    );
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches('[data-mm-digital-consent]')) initializeConsent(node);
          initializeAll(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
